module.exports = __webpack_public_path__ + "static/img/new_float_code.4902b94.png";